import React from 'react';

const CheckboxEmpty = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38 10H10L10 38H38V10ZM10 6C7.79086 6 6 7.79086 6 10V38C6 40.2091 7.79086 42 10 42H38C40.2091 42 42 40.2091 42 38V10C42 7.79086 40.2091 6 38 6H10Z"
      fill="#D9D9D9"
    />
  </svg>
);

export default CheckboxEmpty;
